export default __webpack_public_path__ + "static/media/spaceShipB1.7da49117.png";